import React, { useState } from "react";
import { Search } from "../../assets/icons/icons";

export default function SearchSection() {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    const togglePopup = () => {
        setIsPopupOpen(!isPopupOpen);
    };

    const closePopup = () => {
        setIsPopupOpen(false);
        setSearchTerm("");
    };


    return (
        <div>
            <div className="relative">
                <div className="w-fit cursor-pointer" onClick={togglePopup}>
                    <Search />
                </div>
            </div>
            {isPopupOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                    <div className="bg-white rounded-[10px] p-[20px] w-[90%] max-w-[500px] shadow-lg">
                        <div className="flex justify-between items-center mb-[15px]">
                            <h3 className="text-lg font-bold">Search</h3>
                            <button
                                onClick={closePopup}
                                className="text-gray-500 hover:text-gray-700"
                            >
                                ✖
                            </button>
                        </div>
                        <input
                            type="search"
                            placeholder="Search Product"
                            className="rounded-[7px] w-full py-[9px] px-[15px] bg-[#f5f5f5] border border-gray-300 outline-0 shadow-[0px_0px_10px_#00000024]"
                            value={searchTerm}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}